import { notification } from "antd";
import axios from "axios";
import base64 from "base-64";

import { SIGNIN_INIT, SET_BALANCE, SET_ACCOUNTS } from "../_types";
import { hp, cf, cw } from "../../utils";
import { messagingApi, messagingEndpoints } from "../../api";
import { resetUser } from "../../utils/amplitude";

const setLoginStorage = (user, account) => {
  const old = hp.getCookie("user") || {};
  let ssoUser = {
    user_id: user.userId,
    first_name: user.firstName,
    last_name: user.lastName,
    email: user.email,
    msisdn: user.msisdn,
    account_id: account.accountId,
    role: user.role,
    user_preferences: user.preferences || {},
    status: user.status[0],
    signup_country: user.country,
    profile_image: old.profile_image,
  };

  hp.setCookie("user", JSON.stringify(ssoUser), 7);
  hp.setCookie("account", JSON.stringify(account), 7);
  hp.setCookie("user_id", ssoUser.user_id);
  hp.setCookie("user_name", ssoUser.first_name);
  return ssoUser;
};

export function signIn(intl, lang, data) {
  return (dispatch) => {
    dispatch({ type: SIGNIN_INIT, payload: true });
    axios({
      method: "POST",
      url: `${cf.SSO_URL}/auths/login`,
      headers: {
        Authorization: `Basic ${base64.encode(
          data.email + ":" + data.password
        )}`,
      },
    })
      .then((response) => {
        dispatch({ type: SIGNIN_INIT, payload: false });
        const res = response.data;
        switch (res.statusCode) {
          default:
            // notification.error({
            //     message: intl.formatMessage(cw.signInFailed),
            //     description: intl.formatMessage(cw.invalidCred)
            // });
            break;

          case 401:
            notification.error({
              message: intl.formatMessage(cw.signInFailed),
              description: intl.formatMessage(cw.bruteForcePolice),
            });
            break;
          case 200:
            hp.setCookie("user_token", res.token, 7);
            setLoginStorage(res.data.user, res.data.account);
            // dispatch({ type: SIGNIN_SUCCESS, payload: res });
            dispatch(window.location.assign(`/${lang || "en"}/send-sms`));
            break;
        }
      })
      .catch((err) => {
        dispatch({ type: SIGNIN_INIT, payload: false });
        console.error(err);
        // notification.error({
        //     message: intl.formatMessage(cw.signInFailed),
        //     description: intl.formatMessage(cw.signInFailedDesc)
        // });
      });
  };
}

export function signUp(intl, lang, data) {
  return (dispatch) => {
    dispatch({ type: SIGNIN_INIT, payload: true });
    axios({
      method: "POST",
      url: `${cf.SSO_URL}/auths/signup`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Basic ${base64.encode(
          data.email + ":" + data.password
        )}`,
      },
      data: {
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        industry: data.industry,
        msisdn: data.msisdn.trim().replace("%2B", "+"),
        country: data.country ? data.country : "",
        organizationName: data.organization || "",
        recaptcha: data.recaptcha,
        preferences: data.preferences ? data.preferences : {},
        source: "dfs people",
      },
    })
      .then((response) => {
        dispatch({ type: SIGNIN_INIT, payload: false });
        const res = response.data;
        switch (res.statusCode) {
          default:
            // notification.error({
            //     message: 'Signup Failed',
            //     description: intl.formatMessage(cw.signUpFailed)
            // });
            break;

          case 402:
            notification.error({
              message: intl.formatMessage(cw.Failed),
              description: intl.formatMessage(cw["InvalidInput"]),
            });
            break;
          case 200:
            hp.setCookie("user_token", res.token, 7);
            setLoginStorage(res.data.user, res.data.account);
            dispatch(window.location.assign(`/${lang || "en"}/send-sms`));
            break;
        }
      })
      .catch((err) => {
        dispatch({ type: SIGNIN_INIT, payload: false });
        notification.error({
          message: intl.formatMessage(cw.Failed),
          description: intl.formatMessage(cw.signUpFailed),
        });
      });
  };
}

export function resetPwd(intl, lang, data) {
  return (dispatch) => {
    const authType = data.authType;
    dispatch({ type: SIGNIN_INIT, payload: true });
    axios({
      method: "POST",
      url: `${cf.SSO_URL}/auths/forgot`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: { userName: data.userName, language: lang },
    })
      .then((response) => {
        dispatch({ type: SIGNIN_INIT, payload: false });
        const res = response.data;
        switch (res.statusCode) {
          default:
            // notification.error({
            //     message: intl.formatMessage(cw.Failed),
            //     description: 'Unable to reset password. Please try again'
            // });
            break;
          case 200:
            if (authType === "msisdn") {
              notification.success({
                message: intl.formatMessage(cw.Success),
                description: intl.formatMessage(cw.resetTokenSent),
              });
            } else {
              notification.success({
                message: intl.formatMessage(cw.Success),
                description: intl.formatMessage(cw.resetEmailSent),
              });
            }
            break;
        }
      })
      .catch((err) => {
        dispatch({ type: SIGNIN_INIT, payload: false });
        notification.error({
          message: intl.formatMessage(cw.Failed),
          description: intl.formatMessage(cw.resetEmailFailed),
        });
      });
  };
}

export function signOut() {
  resetUser();
  const lang = window.location.pathname.split("/")[1] || "en";
  let baseurl = process.env.REACT_APP_SSO_WEB_URL;
  const pushSsoLogin = hp.getCookie("AUTH_ORIGIN") === 'Push_SSO'
  pushSsoLogin && (baseurl = process.env.REACT_APP_PUSH_SSO_WEB_URL);
  window.location.assign(
    `${baseurl}/${lang}/signout?continue=${encodeURI(
      window.location.href
    )}`
  );
  // return dispatch => {
  //     hp.deleteCookie('user_token', hp.getCookie('user_token'));
  //     hp.delStorage('user');
  //     hp.delStorage('user_id');
  //     hp.delStorage('esokoUserPreferences');
  //     hp.delStorage('sortedColumns');
  //     dispatch(window.location.assign(`/en/signin`));
  //     dispatch({ type: SIGNOUT_SUCCESS });
  // }
}

export function getAccountBalance() {
  return (dispatch) => {
    messagingApi
      .get({ url: messagingEndpoints.balance, shouldResolve: false })
      .then((response) => {
        if (response.status === 200) {
          dispatch({ type: SET_BALANCE, payload: parseFloat(response.data.data.balance) });
        }
      })
      .catch(() => {});
  };
}

export function fetchAccounts() {
  return (dispatch, getState) => {
    const {
      auth: { user, account },
    } = getState();
    if (!user.user_id) return;
    axios({
      method: "GET",
      url: `${cf.SSO_API}/users/${user.user_id.trim()}/accounts`,
      headers: { "x-access-token": hp.getCookie("user_token") },
    })
      .then((response) => {
        const res = response.data;
        if (res.statusCode === 200) {
          const activeAccount = res.data.find((row) => row.id === account.id);
          if (activeAccount) {
            hp.setCookie("active_account", JSON.stringify(activeAccount));
          }
          dispatch({ type: SET_ACCOUNTS, payload: res.data });
        }
      })
      .catch(() => {});
  };
}

export function accountLogin(accountId, userId) {
  return Promise.all([
    axios({
      method: "POST",
      url: `${cf.SSO_API}/auth/account-logins`,
      headers: { "x-access-token": hp.getCookie("user_token") },
      data: {
        accountId,
        userId,
      },
    }),
    axios({
      method: "GET",
      url: `${cf.SSO_API}/user-accounts/${userId}/${accountId}`,
      headers: { "x-access-token": hp.getCookie("user_token") },
    }),
  ])
    .then((res) => {
      const accountLoginsRes = res[0].data;
      const userRoleRes = res[1].data;
      if (
        accountLoginsRes.statusCode === 200 &&
        userRoleRes.statusCode === 200
      ) {
        return {
          accountToken: accountLoginsRes.token,
          userRole: userRoleRes.data.role,
        };
      }
      throw Error("Unable to switch account");
    })
    .catch((e) => {
      throw e;
    });
}
